import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
} from "@mui/material";

export interface ItemStatusValue {
    in: boolean;
    out: boolean;
    destroyed: boolean;
    pending: boolean;
    permout: boolean;
}

export interface ItemStatusProps {
    value: ItemStatusValue;
    onChange: (value: ItemStatusValue) => void;
}

export default function ItemStatus(props: ItemStatusProps): JSX.Element {
    const { value, onChange } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange({ ...value, [event.target.name]: event.target.checked });
    };

    return (
        <FormControl component="fieldset" sx={{
            marginTop: 1,
            minWidth: 120,
        }}>
            <FormLabel component="legend" sx={{ color: "#000000", textAlign:"left" }}>Item status</FormLabel>
            <FormGroup row>
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.in} onChange={handleChange} name="in" />}
                    label="In"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.out} onChange={handleChange} name="out" />}
                    label="Out"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.destroyed} onChange={handleChange} name="destroyed" />}
                    label="Destroyed"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.pending} onChange={handleChange} name="pending" />}
                    label="Pending"
                />
                <FormControlLabel
                    control={<Checkbox color="secondary" checked={value.permout} onChange={handleChange} name="permout" />}
                    label="Perm. Out"
                />
            </FormGroup>
        </FormControl>
    );
}
